.stickyDayLabel {
  position: absolute;
  left: 0;
  top: 8px;
  z-index: 3;
  display: flex;
  align-items: flex-end;
  height: 18px;
  padding: 0 4px 0 8px;
  font-size: 18px;
  font-weight: normal;
  color: var(--tractie-color-content-emphasis);
  background-color: var(--tractie-color-background-default);
  pointer-events: none;
  white-space: nowrap;
}
